import { Stack, useTheme } from "@mui/material";
import { InfoSection } from "./InfoSection";
import { IngredientSection } from "./IngredientSection";
import { ContributorsSection } from "./Contributors";
import { SupplierFormType } from "../../SupplierForm.types";
import type { SupplierFormAppearance } from "../../SupplierForm.types";
import { SupplierFormContent } from "../../SupplierFormLayout";

type Page4Props = {
    appearance?: SupplierFormAppearance;
    supplier: SupplierFormType;
};
const Page4 = (props: Page4Props) => {
    const { appearance = "legacy", supplier } = props;
    const theme = useTheme();

    if (appearance === "legacy") {
        return (
            <div>
                <Stack direction="column" useFlexGap gap={theme.spacing(1)}>
                    <InfoSection appearance="legacy" supplier={supplier} />
                    <ContributorsSection appearance="legacy" users={supplier.users} />
                    <IngredientSection appearance="legacy" supplier={supplier} />
                </Stack>
            </div>
        );
    }

    return (
        <SupplierFormContent>
            <Stack direction="column" useFlexGap gap={theme.spacing(2)}>
                <InfoSection appearance="product-v2" supplier={supplier} />
                <ContributorsSection appearance="product-v2" users={supplier.users} />
                <IngredientSection appearance="product-v2" supplier={supplier} />
            </Stack>
        </SupplierFormContent>
    );
};
export default Page4;
